import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "./../../../../common/StyledToolTip";
import ToggleAnchorPoints from "./ToggleAnchorPoints";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import appConstants from "../../../../../appConstants";
import SearchBox from "../../../../common/SearchBox";
import WatchTutorial from "../../../../InAppTutorial/WatchTutorial";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  headerStyle: {
    margin: "5px 0px",
    height: "30px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  toggleIconLayout: {
    float: "right",
    display: "flex",
    color: theme.iconColor,
    "&>span": {
      color: theme.iconColor,
    },
    alignItems: "center",
    height: "19px",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
});

const AnchorPointGridHeader = ({
  classes,
  gridApi,
  updateQuickFilterText,
  isAddUpdateAnchorPointFormOpen,
  isToggleEnabled,
  selectedAnchorPoints,
  addAnchorPointOpen,
  updateAnchorPointOpen,
  onBulkAnchorPointToggleClicked,
  deleteAnchorPointPopupOpen,
  isEnableAnchorPointsInProgress,
  featureFlags,
}) => {
  const getIconTitle = (params) => {
    const {
      iconName,
      isAddUpdateAnchorPointFormOpen,
      isToggleEnabled,
      disableEditDeleteIcon,
      disableAddIcon,
      selectedAnchorPoints
    } = params;
    if (isAddUpdateAnchorPointFormOpen) {
      return "Add/update in progress";
    }
    switch (iconName) {
      case "toggleAllAnchorPoint":
        if (selectedAnchorPoints.length > 0) {
          return isToggleEnabled
            ? "Disable selected"
            : "Enable selected";
        } else {
          return isToggleEnabled
            ? "Disable all anchor points"
            : "Enable all anchor points";
        }
      case "deleteIcon":
        if (!disableEditDeleteIcon) {
          return "Click to delete";
        } else {
          return "Select a row to delete";
        }
      case "editIcon":
        if (!disableEditDeleteIcon) {
          return "Click to edit";
        } else {
          return "Select a row to edit";
        }
      case "addIcon":
        return disableAddIcon ? "Disabled" : "Click to add";
      default:
        return "";
    }
  };

  const handleAnchorPointToggle = () => {
    if (isAddUpdateAnchorPointFormOpen) {
      return null;
    }
    onBulkAnchorPointToggleClicked({enableAllAnchorPoints: !isToggleEnabled})
  }

  const allowAddAnchorPoint = featureFlags.isFeatureEnabled(
    appConstants.features.AllowAddAnchorPoint
  );
  const disableAddIcon = !allowAddAnchorPoint || isAddUpdateAnchorPointFormOpen;
  const disableEditDeleteIcon =
    !selectedAnchorPoints.length ||
    isAddUpdateAnchorPointFormOpen 
  const params = {
    isAddUpdateAnchorPointFormOpen,
    disableEditDeleteIcon,
    isToggleEnabled,
    disableAddIcon,
    selectedAnchorPoints
  };
  return (
    <div className={classes.headerStyle}>
      <div
        className={classes.headerLabel}
        data-automationid="anchorPoint-title"
      >
        Anchor Point
      </div>
      <div className={classes.iconContainer}>
        <span>
          <SearchBox onChange={updateQuickFilterText} />
        </span>
        <WatchTutorial
          componentId={appConstants.gridNames.AnchorPointGrid}
          classes={{ iconLayout: classes.iconLayout, headerIconStyles: classes.headerIconStyles }}
        />
        <span>
          <ClearAllFilterButton gridApi={gridApi} />
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.toggleIconLayout} ${
            isAddUpdateAnchorPointFormOpen ? classes.disableIcon : ""
          }`}
        >
          <ToggleAnchorPoints
            isEnabled={isToggleEnabled}
            isOnClickDisabled={isAddUpdateAnchorPointFormOpen}
            title={getIconTitle({
              iconName: "toggleAllAnchorPoint",
              ...params,
            })}
            isEnableAnchorPointsInProgress={isEnableAnchorPointsInProgress}
            selectedAnchorPoints={selectedAnchorPoints}
            onClick={handleAnchorPointToggle}
            className={
              isAddUpdateAnchorPointFormOpen
                ? classes.disableIcon
                : classes.enableIcon
            }
          />
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableEditDeleteIcon ? classes.disableIcon : classes.enableIcon
          }`}
          onClick={!disableEditDeleteIcon ? deleteAnchorPointPopupOpen : null}
        >
          <Tooltip title={getIconTitle({ iconName: "deleteIcon", ...params })}>
            <DeleteOutlineIcon />
          </Tooltip>
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableEditDeleteIcon ? classes.disableIcon : classes.enableIcon
          }`}
          onClick={!disableEditDeleteIcon ? updateAnchorPointOpen : null}
        >
          <Tooltip title={getIconTitle({ iconName: "editIcon", ...params })}>
            <EditIcon />
          </Tooltip>
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout}  ${
            disableAddIcon
              ? classes.disableIcon
              : classes.enableIcon
          }`}
          onClick={allowAddAnchorPoint ? addAnchorPointOpen : null}
        >
          <Tooltip title={getIconTitle({ iconName: "addIcon", ...params })}>
            <AddRoundedIcon />
          </Tooltip>
        </span>
      </div>
    </div>
  );
};
export default compose(
  withStyles(styles),
  withFeatureFlags
)(AnchorPointGridHeader);
